import React, { useState, useRef, useContext } from "react";
import { Link } from "gatsby";
import { useForm } from "react-hook-form";
import { useTranslatorRegister } from "hooks/Forms/useTranslatorRegister";
import { CountryArray } from "utils/constants";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import Modal from "components/popup";
import Loader from "components/loader";
import DataProvider from "Context/DataContext";
import { useLocation } from "@reach/router";

function ThirdStepAccount({ createAccountData, setCurrentStep }) {
  const {
    firstStepData,
    cvUpload,
    nativeLangData,
    expertiseData,
    originalLangData,
    targetLangData,
  } = useContext(DataProvider);
  // console.log(cvUpload);

  const { usernameFinalStepData, setUsernameFinalStepData } =
    useContext(DataProvider);
  const { addressFinalStepData, setAddressFinalStepData } =
    useContext(DataProvider);
  const { cityFinalStepData, setCityFinalStepData } = useContext(DataProvider);
  const { staFinalStepData, setStaFinalStepData } = useContext(DataProvider);
  const { countryFinalStepData, setCountryFinalStepData } =
    useContext(DataProvider);
  const { zipFinalStepData, setZipFinalStepData } = useContext(DataProvider);

  const [showPayment, setShowPayment] = useState(false);
  const [token, setToken] = useState(false);
  const captchaRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [sameAddress, setSameAddress] = useState(false);
  // const [checkBox, setCheckBox] = useState(false);
  const location = useLocation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useTranslatorRegister();
  const onSubmit = (data) => {
    const formData = new FormData();

    if (token) {
      var postData = [];
      if (data.is_billing_address_same_as_contact_address === true) {
        postData = formData.append("first_name", firstStepData.first_name);
        formData.append("last_name", firstStepData.business_name);
        formData.append("cv_file", cvUpload);

        formData.append("business_name", firstStepData.business_name);

        formData.append("link_to_proz", firstStepData.link_to_proz);

        formData.append("username", firstStepData.username);

        formData.append("email", firstStepData.email);

        formData.append("password", firstStepData.password);

        formData.append("web_address", firstStepData.web_address);

        formData.append("phone_number", firstStepData.phone_number);

        formData.append("address", firstStepData.address);

        formData.append("city", firstStepData.city);

        formData.append("state", firstStepData.state);

        formData.append("country", firstStepData.country);

        formData.append("zipcode", firstStepData.zipcode);

        formData.append("translator_comment", firstStepData.translator_comment);

        formData.append("native_language", nativeLangData);

        formData.append("expertise_field", expertiseData);

        formData.append("original_language", originalLangData);

        formData.append("target_language", targetLangData);
        formData.append("payment_choose_later", data.payment_choose_later);
        formData.append(
          "is_billing_address_same_as_contact_address",
          data.is_billing_address_same_as_contact_address
        );

        formData.append("paypal_username", firstStepData.first_name);

        formData.append("billing_address", firstStepData.address);

        formData.append("billing_city", firstStepData.city);

        formData.append("billing_state", firstStepData.state);

        formData.append("billing_country", firstStepData.country);

        formData.append("billing_zipcode", firstStepData.zipcode);

        formData.append("pagelink", location.href);
      } else {
        formData.append("first_name", firstStepData.first_name);
        formData.append("last_name", firstStepData.business_name);
        formData.append("cv_file", cvUpload);
        formData.append("first_name", firstStepData.first_name);

        formData.append("business_name", firstStepData.business_name);

        formData.append("link_to_proz", firstStepData.link_to_proz);

        formData.append("username", firstStepData.username);

        formData.append("email", firstStepData.email);

        formData.append("password", firstStepData.password);

        formData.append("web_address", firstStepData.web_address);

        formData.append("phone_number", firstStepData.phone_number);

        formData.append("address", firstStepData.address);

        formData.append("city", firstStepData.city);

        formData.append("state", firstStepData.state);

        formData.append("country", firstStepData.country);

        formData.append("zipcode", firstStepData.zipcode);

        formData.append("translator_comment", firstStepData.translator_comment);

        formData.append("native_language", nativeLangData);

        formData.append("expertise_field", expertiseData);

        formData.append("original_language", originalLangData);

        postData = formData.append(
          "payment_choose_later",
          data.payment_choose_later
        );

        formData.append(
          "is_billing_address_same_as_contact_address",
          data.is_billing_address_same_as_contact_address
        );

        formData.append("paypal_username", usernameFinalStepData);

        formData.append("billing_address", addressFinalStepData);

        formData.append("billing_city", cityFinalStepData);

        formData.append("billing_state", staFinalStepData);

        formData.append("billing_country", countryFinalStepData);

        formData.append("billing_zipcode", zipFinalStepData);

        formData.append("pagelink", location.href);
      }

      // if (token) {
      //   if (data.is_billing_address_same_as_contact_address === true) {
      //     postData = {
      //       first_name: firstStepData.first_name,
      //       last_name: firstStepData.last_name,
      //       business_name: firstStepData.business_name,
      //       cv_file: cvUpload,
      //       link_to_proz: firstStepData.link_to_proz,
      //       username: firstStepData.username,
      //       email: firstStepData.email,
      //       password: firstStepData.password,
      //       web_address: firstStepData.web_address,
      //       phone_number: firstStepData.phone_number,
      //       address: firstStepData.address,
      //       city: firstStepData.city,
      //       state: firstStepData.state,
      //       country: firstStepData.country,
      //       zipcode: firstStepData.zipcode,
      //       translator_comment: firstStepData.translator_comment,
      //       native_language: nativeLangData,
      //       expertise_field: expertiseData,
      //       original_language: originalLangData,
      //       target_language: targetLangData,
      //       payment_choose_later: data.payment_choose_later,
      //       is_billing_address_same_as_contact_address:
      //         data.is_billing_address_same_as_contact_address,
      //       paypal_username: firstStepData.first_name,
      //       billing_address: firstStepData.address,
      //       billing_city: firstStepData.city,
      //       billing_state: firstStepData.state,
      //       billing_country: firstStepData.country,
      //       billing_zipcode: firstStepData.zipcode,
      //       pagelink: location.href,
      //     };
      //   } else {
      //     postData = {
      //       payment_choose_later: data.payment_choose_later,
      //       is_billing_address_same_as_contact_address:
      //         data.is_billing_address_same_as_contact_address,
      //       paypal_username: usernameFinalStepData,
      //       billing_address: addressFinalStepData,
      //       billing_city: cityFinalStepData,
      //       billing_state: staFinalStepData,
      //       billing_country: countryFinalStepData,
      //       billing_zipcode: zipFinalStepData,
      //       pagelink: location.href,
      //     };
      //   }

      mutateAsync(formData).then((response) => {
        if (response.success === 1) {
          setOpen(true);
          reset();
          setCurrentStep(1);
        } else {
          alert(response.message);
        }
      });
    } else {
      alert("Please verify captcha");
    }
  };

  const handleVerify = () => {
    setToken(true);
  };

  const handleChangeName = (event) => {
    setUsernameFinalStepData(event.target.value);
  };
  const handleChangeAddress = (event) => {
    setAddressFinalStepData(event.target.value);
  };
  const handleChangeCity = (event) => {
    setCityFinalStepData(event.target.value);
  };
  const handleChangeState = (event) => {
    setStaFinalStepData(event.target.value);
  };
  const handleChangeCountry = (event) => {
    setCountryFinalStepData(event.target.value);
  };
  const handleChangeZip = (event) => {
    setZipFinalStepData(event.target.value);
  };

  if (addressFinalStepData) {
    setShowPayment(true);
  }

  return (
    <div>
      <div className="rounded-lg bg-black py-5 px-12 h-full mx-4 md:w-10/12 lg:w-9/12 flex flex-col justify-center md:mx-auto max-w-[800px] font-primary relative">
        <p className="text-center text-white text-xl px-4">
          We pay you through PayPal or Money Bookers
        </p>
        <p className="text-center text-white text-xl px-4 mb-8">
          (We plan to offer more options in the future).
        </p>
        <p className="text-white text-xl mb-3">
          Please enter your billing information:
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal open={open} setOpen={setOpen} />
          <div className="relative">
            <div className="flex gap-32 mb-10">
              <div>
                <input
                  type="radio"
                  id="paypal"
                  name="payment_choose_later"
                  value="paypal"
                  checked={showPayment || (addressFinalStepData && "checked")}
                  className="cursor-pointer"
                  {...register("payment_choose_later")}
                  onClick={() => {
                    setShowPayment(true);
                  }}
                />
                <label
                  for="paypal"
                  className="text-lg text-white font-bold ml-2 cursor-pointer"
                >
                  Paypal
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="choose_later"
                  name="payment_choose_later"
                  value="choose_later"
                  checked={!showPayment && "checked"}
                  className="cursor-pointer"
                  {...register("payment_choose_later")}
                  onClick={() => setShowPayment(false)}
                />
                <label
                  for="choose_later"
                  className="text-lg text-white font-bold ml-2 cursor-pointer"
                >
                  Choose Later
                </label>
              </div>
            </div>
            {showPayment && (
              <div>
                <div>
                  <input
                    type="checkbox"
                    id="is_billing_address_same_as_contact_address"
                    name="is_billing_address_same_as_contact_address"
                    {...register("is_billing_address_same_as_contact_address")}
                    onChange={() => {
                      setSameAddress(!sameAddress);
                      // setCheckBox(!checkBox)
                    }}
                    // checked={!checkBox ? showPayment : null}
                  />
                  <label
                    for="is_billing_address_same_as_contact_address"
                    className="text-base text-white ml-2"
                  >
                    Same as Contact Information
                  </label>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-20 gap-y-6 mb-8 mt-5">
                  <div className="w-full relative">
                    <input
                      type="text"
                      placeholder="Paypal Username*"
                      className="rounded pl-3 text-black py-1 w-full"
                      id="paypal_username"
                      name="paypal_username"
                      {...register("paypal_username")}
                      onChange={(e) => handleChangeName(e)}
                      defaultValue={usernameFinalStepData}
                    />
                    {errors.paypal_username && (
                      <span className="text-red text-xs absolute left-0 -bottom-5">
                        This field is required
                      </span>
                    )}
                  </div>
                  <textarea
                    name="billing_address"
                    id="billing_address"
                    cols="30"
                    rows="4"
                    placeholder="Address"
                    className="rounded pl-3 text-black py-1"
                    defaultValue={
                      !sameAddress
                        ? addressFinalStepData
                        : firstStepData.address
                    }
                    onChange={(e) => handleChangeAddress(e)}
                  >
                    {errors.billing_address && (
                      <span className="text-red text-xs absolute left-0 -bottom-5">
                        This field is required
                      </span>
                    )}
                  </textarea>
                  <div className="w-full relative">
                    <input
                      type="text"
                      placeholder="City"
                      className="rounded pl-3 text-black py-1 w-full"
                      id="billing_city"
                      name="billing_city"
                      defaultValue={
                        !sameAddress ? cityFinalStepData : firstStepData.city
                      }
                      onChange={(e) => handleChangeCity(e)}
                    />
                    {errors.billing_city && (
                      <span className="text-red text-xs absolute left-0 -bottom-5">
                        This field is required
                      </span>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="State"
                    className="rounded pl-3 text-black py-1"
                    id="billing_state"
                    name="billing_state"
                    defaultValue={
                      !sameAddress ? staFinalStepData : firstStepData.state
                    }
                    onChange={(e) => handleChangeState(e)}
                  />
                  <select
                    className="rounded pl-3 text-black py-1"
                    id="billing_country"
                    name="billing_country"
                    defaultValue={
                      !sameAddress
                        ? countryFinalStepData
                        : firstStepData.country
                    }
                    onChange={(e) => handleChangeCountry(e)}
                  >
                    <option className="text-gray-700 text-lg" disabled selected>
                      Select Country
                    </option>
                    {CountryArray
                      ? CountryArray.map(({ name }, index) => (
                          <option
                            key={index}
                            value={name}
                            className="text-gray-700 text-lg"
                          >
                            {name}
                          </option>
                        ))
                      : null}
                  </select>
                  <input
                    type="text"
                    placeholder="Zip Code"
                    className="rounded pl-3 text-black py-1"
                    id="billing_zipcode"
                    name="billing_zipcode"
                    defaultValue={
                      !sameAddress ? zipFinalStepData : firstStepData.zipcode
                    }
                    onChange={(e) => handleChangeZip(e)}
                  />
                </div>
              </div>
            )}
            <HCaptcha
              sitekey="b6b06718-08ae-457f-a6d7-147046b4c216"
              onVerify={handleVerify}
              ref={captchaRef}
            />
            <p className="text-white mt-10 mb-2">
              By clicking button below, You are agreeing to the Users{" "}
              <a
                href="https://www.tomedes.com/user-agreement"
                target="_blank"
                className="text-lightBlue"
              >
                Terms of Service
              </a>
              &nbsp;and&nbsp;
              <a
                href="https://www.tomedes.com/privacy"
                target="_blank"
                className="text-lightBlue"
              >
                Privacy Policy.
              </a>
            </p>
            <p className="text-white pb-16">
              If you encounter any problems signing up, Please{" "}
              <a
                href="https://www.tomedes.com/contactus.php"
                target="_blank"
                className="text-lightBlue"
              >
                Contact
              </a>
              &nbsp;us or&nbsp;
              <a
                href="https://server.iad.liveperson.net/hc/4900916/?cmd=file%C2%A0file=visitorWantsToChat%C2%A0site=4900916%C2%A0byhref=1%C2%A0imageUrl=https://server.iad.liveperson.net/hcp/Gallery/ChatButton-Gallery/English/General/1a/"
                className="text-lightBlue"
              >
                chat now
              </a>
              &nbsp;with our live agents.
            </p>
            <button className="bg-lightBlue text-white max-w-max rounded py-1 px-5 absolute right-0 bottom-0">
              {status === "loading" ? <Loader /> : "Submit"}
            </button>
          </div>
        </form>
        <button
          onClick={() => {
            setCurrentStep(2);
          }}
          className="text-white absolute bottom-[-40px] left-0 hover:text-lightBlue "
        >
          Return to second step
        </button>
      </div>
    </div>
  );
}

export default ThirdStepAccount;
